import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function CheckOpenPorts() {
    return (
        <div className={globalStyles.article}>
            <h1>Checking open ports &amp; listening sockets</h1>

            <p><b>ss</b> is the modern replacement for <b>netstat</b> (which is deprecated on most distros but
                still around on older systems).</p>

            <pre className={globalStyles.code}>
    <b>user@host:~$</b> ss -tulpn <i># TCP+UDP listening sockets, with process name</i><br/>
    <b>user@host:~$</b> ss -tan <i># all TCP connections, numeric</i><br/>
    <b>user@host:~$</b> ss -tan state established <i># only established connections</i><br/>
            </pre>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">ss flags</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>-t</b></td>
                        <td>TCP sockets</td>
                    </tr>
                    <tr>
                        <td><b>-u</b></td>
                        <td>UDP sockets</td>
                    </tr>
                    <tr>
                        <td><b>-l</b></td>
                        <td>Only listening sockets</td>
                    </tr>
                    <tr>
                        <td><b>-p</b></td>
                        <td>Show the owning process (needs root for other users' processes)</td>
                    </tr>
                    <tr>
                        <td><b>-n</b></td>
                        <td>Numeric — skip resolving hostnames/service names</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <p>Equivalent with the older tool:</p>
            <pre className={globalStyles.code}><b>root@host:~#</b> netstat -tulpn</pre>

            <h3>Which process owns a specific port?</h3>
            <pre className={globalStyles.code}>
    <b>root@host:~#</b> lsof -i :443<br/>
    <b>root@host:~#</b> ss -tulpn | grep :443<br/>
            </pre>

            <h3>Is a remote port reachable?</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> nc -zv example.com 443 <i># TCP connect test, no data sent</i><br/>
    <b>user@host:~$</b> curl -v telnet://example.com:443<br/>
            </pre>
        </div>
    )
}
